var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParkingInventory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.827,
    height: 33.932,
    viewBox: "0 0 28.827 33.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9087"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7833",
    d: "M31.238 14.518A13.9 13.9 0 1 0 7.59 25.688l8.668 8.684a1.635 1.635 0 0 0 2.322 0l8.635-8.684a13.836 13.836 0 0 0 4.023-11.17zm-6.313 8.864L17.4 30.905l-7.521-7.523a10.614 10.614 0 0 1-3.058-8.537 10.745 10.745 0 0 1 4.726-7.9 10.581 10.581 0 0 1 11.71 0 10.745 10.745 0 0 1 4.726 7.866 10.614 10.614 0 0 1-3.058 8.57z",
    transform: "translate(-2.988 -1.424)",
    style: {
      fill: "currentColor",
      stroke: "var(--sidebar-surface)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7839",
    d: "M11.109 22.091a1.509 1.509 0 0 0 1.509-1.509v-3.32h2.113a5.131 5.131 0 1 0 0-10.262h-3.622A1.509 1.509 0 0 0 9.6 8.509v12.073a1.509 1.509 0 0 0 1.509 1.509zm5.736-9.96a2.115 2.115 0 0 1-2.113 2.113h-2.114v-4.226h2.113a2.115 2.115 0 0 1 2.113 2.113z",
    transform: "translate(.851 .38)",
    style: {
      fill: "currentColor",
      stroke: "var(--sidebar-surface)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingInventory);
export default __webpack_public_path__ + "static/media/parking_inventory.0646f0964da7b3c0f4976cc2fbdaf50f.svg";
export { ForwardRef as ReactComponent };